import type { IconName } from './icons';
import type { UploadFormat } from './uploadTypes';

/** How a detected format is named and drawn. Pure, so it is testable alone. */

export const FORMAT_LABELS: Record<UploadFormat, string> = {
  pdf: 'PDF',
  doc: 'Word (.doc)',
  docx: 'Word (.docx)',
  txt: 'Plain text',
};

/** The icon for what the bytes turned out to be — never what the name claimed. */
export function formatIcon(format: UploadFormat): IconName {
  switch (format) {
    case 'pdf':
      return 'pdf';
    case 'doc':
    case 'docx':
      return 'doc';
    case 'txt':
      return 'txt';
  }
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
